import React from "react";
import { getFireExplosionVariantKey } from "../packageUtils";

export default function FireExplosionCompanySelector({
  variants,
  selectedVariantKey,
  onSelectVariant,
}) {
  if (!variants || variants.length <= 1) return null;

  return (
    <div className="fire-explosion__company-block">
      <h2 className="fire-explosion__section-title fire-explosion__section-title--spaced">
        Công ty bảo hiểm
      </h2>
      <div className="fire-explosion__company-list" role="radiogroup" aria-label="Chọn công ty bảo hiểm">
        {variants.map((v, idx) => {
          const key = getFireExplosionVariantKey(v, idx);
          const active = key === selectedVariantKey;
          const code = String(v.company?.code || "").trim() || "—";
          const logo = v.company?.image || v.image;
          return (
            <button
              key={key}
              type="button"
              role="radio"
              aria-checked={active}
              className={`fire-explosion__company-chip${active ? " fire-explosion__company-chip--active" : ""}`}
              onClick={() => onSelectVariant(key)}
            >
              <span className="fire-explosion__company-chip-logo-wrap">
                {logo ? (
                  <img className="fire-explosion__company-chip-logo" src={logo} alt="" />
                ) : (
                  <span className="fire-explosion__company-chip-logo-fallback" aria-hidden>
                    {code.slice(0, 3)}
                  </span>
                )}
              </span>
              <span className="fire-explosion__company-chip-code">{code}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
